<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { FeaturesBlock } from '../../types'

defineProps<{ block: FeaturesBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container site:grid site:gap-12 site:@min-[64rem]:grid-cols-[0.8fr_1.2fr] site:@min-[64rem]:gap-20">
      <div>
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-5 site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
        <SiteLink v-if="block.content.action" :link="block.content.action" class="site-site-button site:mt-7">
          {{ block.content.action.label }}
        </SiteLink>
      </div>

      <ol class="site:border-t site:border-(--site-color-border)">
        <li
          v-for="(item, index) in block.content.items"
          :key="item.id"
          class="site:grid site:gap-4 site:border-b site:border-(--site-color-border) site:py-7 site:@min-[40rem]:grid-cols-[3.5rem_1fr] site:@min-[40rem]:gap-6"
        >
          <span class="site-heading site:text-sm site:font-bold site:text-(--site-color-primary)">
            {{ String(index + 1).padStart(2, '0') }}
          </span>
          <div class="site:grid site:gap-2 site:@min-[40rem]:grid-cols-[0.8fr_1.2fr] site:@min-[40rem]:gap-8">
            <SiteEditableText v-model="item.title" as="h3" class="site-heading site:text-xl site:font-bold site:tracking-tight" />
            <SiteEditableText v-model="item.description" as="p" class="site:leading-7 site:text-(--site-color-muted-text)" />
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>
